import * as actionTypes from "../../mutation-types";
import PersonServiceProvider from "../../../providers/idp/PersonServiceProvider";
import ServerLogProvider from "../../../providers/ServerLogProvider";
import LoggerProvider from "../../../providers/LoggerProvider";
import IdpManagementProvider from "../../../providers/idp/IdpManagementProvider";
import appConfig from "../../../appconfig";

const emptyPersonData = () => undefined;
/**
 * Person Data will ook something like this:
 * {
			firstname: undefined,
			lastname: undefined,
			phoneNumber: undefined,
			emailNewsletter: undefined,
			birthDate: undefined,
			day: undefined,
			month: undefined,
			year: undefined,
			email: undefined,
			countryCode: undefined
		}
 */
const state = {
	persistedData: {
		personData: emptyPersonData()
	}
};

const getters = {
	personData: (state) => {
		return state.persistedData.personData;
	}
};

const actions = {
	[actionTypes.PERSON_EXISTS]: async (_, email) => {
		const personExistsResponse = await PersonServiceProvider.verifyPersonExistsByEmail(appConfig.tenantConfig.tenantId, email);
		if(personExistsResponse.data.person.success) {
			return personExistsResponse.data.person.data.data.personExists;
		} else {
			ServerLogProvider.postErrorToServer({msg: "Person service not available."});
			// Redirects to registration if person service fails
			return true;
		}
	},
	[actionTypes.PERSON_DELETE_ACCOUNT]: async ({ commit, getters, dispatch }, { eventName, confirmation }) => {
		// STEP 1: Get users email from localstorage
		const email = getters.personData.email;

		// STEP 2: Check if user with provided email exists in person service
		// TODO: SERVICE RESPONSE IS LOOKING WEIRD, MAKE IT PRETTIER!
		const personExists = await dispatch(actionTypes.PERSON_EXISTS, email);
		LoggerProvider.logEvent({
			message: `Sunset- checking if person exists in person service: ${personExists}`,
			eventName,
			eventCategory: "PersonService",
			eventDomain: "UserAuth",
			data: {
				personExists
			}
		});
		// STEP 3: DELETE USER
		if(personExists){
			try{
				const deletionResponse = await IdpManagementProvider.deleteUserFromIdp(appConfig.tenantConfig.tenantId, getters.applicationUserIdpToken, confirmation);
				const {appUsersModelDeletionRes, personServiceDeletionRes} = deletionResponse.data.auth0Management.data.data;
				if(appUsersModelDeletionRes !== 1 && personServiceDeletionRes !== 204){
					ServerLogProvider.postErrorToServer({msg: `Sunset- user deletion finished unsuccessfully: appUsersModelDeletionRes-${appUsersModelDeletionRes}&personServiceDeletionRes-${personServiceDeletionRes}`});
				}else {
					LoggerProvider.logEvent({
						message: `Sunset- user deletion finished successfully: appUsersModelDeletionRes-${appUsersModelDeletionRes}&personServiceDeletionRes-${personServiceDeletionRes}`,
						eventName,
						eventCategory: "UserDeletion",
						eventDomain: "UserAuth",
						data: {
							appUsersModelDeletionRes,
							personServiceDeletionRes
						}
					});
				}
			} catch(e){
				ServerLogProvider.postErrorToServer(e);

			}
		}
		// STEP 4: LOG OUT
		commit(actionTypes.REMOVE_USER_IDP_TOKEN);
		await dispatch(actionTypes.PERSON_DATA_CLEAR);
		await dispatch(actionTypes.REMOVE_USER_DATA);
	},
	[actionTypes.PERSON_DATA_UPDATE]: async ({ commit, getters }, newData) => {
		const data = {
			...getters.personData,
			...newData
		};
		try {
			await PersonServiceProvider.updatePerson(appConfig.tenantConfig.tenantId, getters.applicationUserIdpToken, data);
			const newPersonData = {
				...data,
				consents: {
					...getters.personData.consents,
					...data.consents
				}
			};

			return commit(actionTypes.PERSON_DATA_SET, generatePersonData(getters.personData, newPersonData));
		} catch (e) {
			return null;
		}
	},
	[actionTypes.PERSON_DATA_SET]({ commit, getters }, user){
		return commit(actionTypes.PERSON_DATA_SET, generatePersonData(getters.personData, user));
	},
	[actionTypes.PERSON_DATA_CLEAR]({ commit }) {
		return commit(actionTypes.PERSON_DATA_CLEAR);
	}
};

const calculateDOB = ({ dateOfBirth, birthDate, year, month, day }) => {
	if (dateOfBirth) {
		return dateOfBirth;
	}
	if (birthDate) {
		return birthDate;
	}
	if (year && month && day) {
		return new Date(
			[ year, `0${month}`.slice(-2), `0${day}`.slice(-2) ].join("-"))
			.toISOString();
	}
};

const generatePersonData = (currentPersonData, sentPerson) => ({
	firstName: sentPerson.firstname || sentPerson.firstName,
	lastName: sentPerson.lastname || sentPerson.lastName,
	phone: sentPerson.phoneNumber || sentPerson.phone,
	countryCode: (sentPerson.countryCode || "").toLowerCase(),
	email: (sentPerson.email || currentPersonData.email).toLowerCase(),
	middleName: sentPerson.middleName,
	dateOfBirth: calculateDOB(sentPerson),
	address: sentPerson.address,
	consents: {
		emailNewsletter: Object.prototype.hasOwnProperty.call(sentPerson, "emailNewsletter")
			? sentPerson.emailNewsletter
			: (sentPerson.consents && sentPerson.consents.emailNewsletter),
		acceptSubscriptionTerms: Object.prototype.hasOwnProperty.call(sentPerson, "acceptSubscriptionTerms")
			? sentPerson.acceptSubscriptionTerms
			: (sentPerson.consents && sentPerson.consents.acceptSubscriptionTerms),
		acceptForbiddenWithdrawal: Object.prototype.hasOwnProperty.call(sentPerson, "acceptForbiddenWithdrawal")
			? sentPerson.acceptForbiddenWithdrawal
			: (sentPerson.consents && sentPerson.consents.acceptForbiddenWithdrawal),
		acceptSunsetPointsTerms: Object.prototype.hasOwnProperty.call(sentPerson, "acceptSunsetPointsTerms")
			? sentPerson.acceptSunsetPointsTerms
			: (sentPerson.consents && sentPerson.consents.acceptSunsetPointsTerms)
	}
});
const mutations = {
	[actionTypes.PERSON_DATA_SET](state, user){
		state.persistedData.personData = {...user};
	},
	[actionTypes.PERSON_DATA_CLEAR](state) {
		state.persistedData.personData = emptyPersonData();
	},
	copyWith(state, user){
		state.persistedData.personData = {...state.persistedData.userData, ...user};
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
